import { compareAsc, format } from "date-fns";

import { AssetType, AssetModel } from "@interfaces/index";

export const filterAssetsByDate = ({
  assets,
  date,
  startPeriodDate,
  excludeTypes,
  excludeDisposed = false,
  hideAssetsWithMiles = false,
}: {
  assets: AssetModel[];
  date?: Date;
  startPeriodDate?: Date;
  excludeTypes?: AssetType[];
  excludeDisposed?: boolean;
  hideAssetsWithMiles?: boolean;
}) => {
  const dateStr = date && format(date, "yyyy-MM-dd");
  const startPeriodDateStr =
    startPeriodDate && format(startPeriodDate, "yyyy-MM-dd");

  const filteredByDates = assets.filter(({ date, disposal }) => {
    const isCreatedDateValid =
      !dateStr || compareAsc(new Date(date), new Date(dateStr)) <= 0;

    const isDisposalDateValid =
      !disposal?.date ||
      !dateStr ||
      (!startPeriodDateStr &&
        compareAsc(new Date(disposal.date), new Date(dateStr)) >= 0) ||
      (startPeriodDateStr &&
        compareAsc(new Date(disposal.date), new Date(startPeriodDateStr)) >= 0);

    return isCreatedDateValid && isDisposalDateValid;
  });

  const filteredByType = excludeTypes?.length
    ? filteredByDates.filter(({ type }) => !excludeTypes.includes(type))
    : filteredByDates;

  const filteredDisposed = excludeDisposed
    ? filteredByType.filter(({ disposal }) => !disposal)
    : filteredByType;

  const filteredWithMiles = hideAssetsWithMiles
    ? filteredDisposed.filter(({ policies }) => policies.canAddTransaction)
    : filteredDisposed;

  return filteredWithMiles;
};

export const filterAssetsByRange = ({
  assets,
  startDate,
  endDate,
  excludeTypes,
  excludeDisposed,
  hideAssetsWithMiles = false,
}: {
  assets: AssetModel[];
  startDate?: Date;
  endDate?: Date;
  excludeTypes?: AssetType[];
  excludeDisposed?: boolean;
  hideAssetsWithMiles?: boolean;
}) => {
  const startDateStr = startDate && format(startDate, "yyyy-MM-dd");
  const endDateStr = endDate && format(endDate, "yyyy-MM-dd");

  const filteredByDates = assets.filter(({ date, disposal }) => {
    const isCreatedDateValid =
      !startDateStr || compareAsc(new Date(date), new Date(startDateStr)) <= 0;

    const isDisposalDateValid =
      !disposal?.date ||
      !endDateStr ||
      compareAsc(new Date(disposal.date), new Date(endDateStr)) >= 0;

    return isCreatedDateValid && isDisposalDateValid;
  });

  const filteredByType = excludeTypes?.length
    ? filteredByDates.filter(({ type }) => !excludeTypes.includes(type))
    : filteredByDates;

  const filteredDisposed = excludeDisposed
    ? filteredByType.filter(({ disposal }) => !disposal)
    : filteredByType;

  const filteredWithMiles = hideAssetsWithMiles
    ? filteredDisposed.filter(({ policies }) => policies.canAddTransaction)
    : filteredDisposed;

  return filteredWithMiles;
};
